// Static manifest of real product photos placed in /public/product-photos/.
// All product photos are served as optimized WebP (~30-80KB each, resized to
// 900px wide). The original 1-1.5MB PNG sources have been removed to keep the
// deployed bundle light and to avoid mobile users pulling multi-megabyte
// hero shots for every card. Add slug + tab entries here when new photos are
// uploaded. Any {slug, tab} combination NOT listed here falls back to the
// standard PhotoPlaceholder on the product page.
const PRODUCT_PHOTOS = {
  "retatrutide-pen": {
    // Transparent-background cutouts (see /product-photos/retatrutide-40mg-pen/
    // *_t.webp) so cards render seamlessly on the cool card background.
    // Files kept under the legacy `-40mg-pen` directory — only the slug
    // key changed as part of the Retatrutide URL migration (Part 3).
    SEALED: "/product-photos/retatrutide-40mg-pen/sealed_t.webp",
    OPEN: "/product-photos/retatrutide-40mg-pen/open_t.webp",
    PEN: "/product-photos/retatrutide-40mg-pen/pen_t.webp",
  },
  "bpc-157-pen": {
    SEALED: "/product-photos/bpc-157-pen/sealed.webp",
    OPEN: "/product-photos/bpc-157-pen/open.webp",
    PEN: "/product-photos/bpc-157-pen/pen.webp",
  },
  "wolverine-pen": {
    SEALED: "/product-photos/wolverine-pen/sealed.webp",
    OPEN: "/product-photos/wolverine-pen/open.webp",
    PEN: "/product-photos/wolverine-pen/pen.webp",
  },
  "tb-500-pen": {
    SEALED: "/product-photos/tb-500-pen/sealed.webp",
    OPEN: "/product-photos/tb-500-pen/open.webp",
    PEN: "/product-photos/tb-500-pen/pen.webp",
  },
  "pt-141-pen": {
    SEALED: "/product-photos/pt-141-pen/sealed.webp",
    OPEN: "/product-photos/pt-141-pen/open.webp",
    PEN: "/product-photos/pt-141-pen/pen.webp",
  },
  "nad-plus-pen": {
    SEALED: "/product-photos/nad-plus-pen/sealed.webp",
    OPEN: "/product-photos/nad-plus-pen/open.webp",
    PEN: "/product-photos/nad-plus-pen/pen.webp",
  },
  "mots-c-pen": {
    SEALED: "/product-photos/mots-c-pen/sealed.webp",
    OPEN: "/product-photos/mots-c-pen/open.webp",
    PEN: "/product-photos/mots-c-pen/pen.webp",
  },
  "klow-pen": {
    SEALED: "/product-photos/klow-pen/sealed.webp",
    OPEN: "/product-photos/klow-pen/open.webp",
    PEN: "/product-photos/klow-pen/pen.webp",
  },
  "hulk-pen": {
    SEALED: "/product-photos/hulk-pen/sealed.webp",
    OPEN: "/product-photos/hulk-pen/open.webp",
    PEN: "/product-photos/hulk-pen/pen.webp",
  },
  "glow-pen": {
    SEALED: "/product-photos/glow-pen/sealed.webp",
    OPEN: "/product-photos/glow-pen/open.webp",
    PEN: "/product-photos/glow-pen/pen.webp",
  },
  "ghk-cu-pen": {
    SEALED: "/product-photos/ghk-cu-pen/sealed.webp",
    OPEN: "/product-photos/ghk-cu-pen/open.webp",
    PEN: "/product-photos/ghk-cu-pen/pen.webp",
  },
  "cjc-1295-pen": {
    SEALED: "/product-photos/cjc-1295-pen/sealed.webp",
    OPEN: "/product-photos/cjc-1295-pen/open.webp",
    PEN: "/product-photos/cjc-1295-pen/pen.webp",
  },
};

// Single hero image per Raw Vial slug. Unlike Pen Kit photos, Raw Vials
// display ONE static product image — no gallery, no tab-cycle. Add a slug
// entry here when its vial.webp lands under /product-photos/<slug>/.
const VIAL_PHOTOS = {
  "aod-9604": "/product-photos/aod-9604-vial/vial.webp",
  "bpc-157": "/product-photos/bpc-157-vial/vial.webp",
  "cagrilintide": "/product-photos/cagrilintide-vial/vial.webp",
  "cjc-1295-dac": "/product-photos/cjc-1295-dac-vial/vial.webp",
  "cjc-1295-no-dac": "/product-photos/cjc-1295-no-dac-vial/vial.webp",
  "dsip": "/product-photos/dsip-vial/vial.webp",
  "epithalon": "/product-photos/epithalon-vial/vial.webp",
  "ghk-cu": "/product-photos/ghk-cu-vial/vial.webp",
  "glow": "/product-photos/glow-vial/vial.webp",
  "hulk": "/product-photos/hulk-vial/vial.webp",
  "ipamorelin": "/product-photos/ipamorelin-vial/vial.webp",
  "klow": "/product-photos/klow-vial/vial.webp",
  "kpv": "/product-photos/kpv-vial/vial.webp",
  "melanotan-1": "/product-photos/melanotan-i-vial/vial.webp",
  "melanotan-2": "/product-photos/melanotan-ii-vial/vial.webp",
  "mots-c": "/product-photos/mots-c-vial/vial.webp",
  "nad-plus": "/product-photos/nad-plus-vial/vial.webp",
  "pt-141": "/product-photos/pt-141-vial/vial.webp",
  "retatrutide": "/product-photos/retatrutide-vial/vial.webp",
  "selank": "/product-photos/selank-vial/vial.webp",
  "semaglutide-vial": "/product-photos/semaglutide-vial/vial.webp",
  "semax": "/product-photos/semax-vial/vial.webp",
  "tb-500": "/product-photos/tb-500-vial/vial.webp",
  "tirzepatide-vial": "/product-photos/tirzepatide-vial/vial.webp",
  "wolverine": "/product-photos/wolverine-vial/vial.webp",
  // Vial Kits — composite kit shots (vial + syringes + swabs + sharps bin).
  // Resolved via getVialPhoto (format vial_kit) across grid card, PDP and nav
  // flyout. Match each photo to its compound by the vial label.
  "klow-vial-kit": "/product-photos/klow-vial-kit/vial.webp",
  "glow-vial-kit": "/product-photos/glow-vial-kit/vial.webp",
  "hulk-vial-kit": "/product-photos/hulk-vial-kit/vial.webp",
  "ghk-cu-vial-kit": "/product-photos/ghk-cu-vial-kit/vial.webp",
  "melanotan-ii-vial-kit": "/product-photos/melanotan-ii-vial-kit/vial.webp",
  "nad-plus-vial-kit": "/product-photos/nad-plus-vial-kit/vial.webp",
  "retatrutide-vial-kit": "/product-photos/retatrutide-vial-kit/vial.webp",
  "mots-c-vial-kit": "/product-photos/mots-c-vial-kit/vial.webp",
  "wolverine-vial-kit": "/product-photos/wolverine-vial-kit/vial.webp",
};

export function getVialPhoto(slug) {
  return VIAL_PHOTOS[slug] || null;
}

// Multi-angle gallery for a Vial Kit PDP. Order: (1) primary kit/box shot,
// (2) the standalone Raw Vial photo for the SAME compound (kit slug minus
// the trailing "-kit"), then the disposables that ship in the kit
// (insulin syringes, alcohol wipes, sharps disposal container). Vial Kits
// ship pre-reconstituted, so bacteriostatic water + mixing needles are
// deliberately NOT in this gallery — those live with the Reconstitution
// Kit bundles and standalone Accessories. Nulls are dropped so a kit only
// ever shows angles that actually have an asset.
export function getVialKitGallery(slug) {
  const rawSlug = slug.replace(/-kit$/, "");
  return [
    getVialPhoto(slug),
    getVialPhoto(rawSlug),
    ACCESSORY_PHOTOS["insulin-syringes-30g-8mm-1ml"],
    ACCESSORY_PHOTOS["alcohol-prep-wipes-100"],
    ACCESSORY_PHOTOS["sharps-bin-02l"],
  ].filter(Boolean);
}

// Hero vials receive the premium micro-parallax + shine-sweep hover treatment
// (see `.vial-hero` in index.css). Keep this set small — the effect is meant
// to make flagship compounds feel handled, not to spam every card.
const HERO_VIAL_SLUGS = new Set([
  "retatrutide",
  "semaglutide-vial",
  "tirzepatide-vial",
  "bpc-157",
  "cagrilintide",
]);

export function isHeroVial(slug) {
  return HERO_VIAL_SLUGS.has(slug);
}

export function getProductPhoto(slug, tab) {
  return PRODUCT_PHOTOS[slug]?.[tab] || null;
}

// Accessory hero photos — a single square-crop image per SKU. Wired the same
// way as VIAL_PHOTOS so the card layout stays untouched: ProductCard just
// gets a non-empty photo array and switches to the real <img> stack instead
// of the ProductVisual placeholder. Keep filenames as `hero.webp` under
// /product-photos/{slug}/ to match the existing folder convention.
const ACCESSORY_PHOTOS = {
  "mixing-needle-23g": "/product-photos/mixing-needle-23g/hero.webp",
  "mixing-syringe-needle-3ml-23g": "/product-photos/mixing-syringe-needle-3ml-23g/hero.webp",
  "insulin-syringes-30g-8mm-05ml": "/product-photos/insulin-syringes-30g-8mm-05ml/hero.webp",
  "insulin-syringes-30g-8mm-1ml": "/product-photos/insulin-syringes-30g-8mm-1ml/hero.webp",
  "alcohol-prep-wipes-100": "/product-photos/alcohol-prep-wipes-100/hero.webp",
  "pen-kit-needles-32g-4mm": "/product-photos/pen-kit-needles-32g-4mm/hero.webp",
  "bac-water": "/product-photos/bac-water/hero.webp",
  "sharps-bin-02l": "/product-photos/sharps-bin-02l/hero.webp",
  "travel-case-cooler": "/product-photos/travel-case-cooler/hero.webp",
};

// Size-specific accessory photos, keyed by {slug: {pack_size: url}}. When a
// buyer selects a pack size on the PDP the hero swaps to the matching image
// if one exists here; otherwise the static getAccessoryPhoto() image is used.
const ACCESSORY_VARIANT_PHOTOS = {
  "bac-water": {
    3: "/product-photos/bac-water/hero.webp",
    10: "/product-photos/bac-water/hero-10ml.webp",
  },
};

export function getAccessoryPhoto(slug) {
  return ACCESSORY_PHOTOS[slug] || null;
}

// Multi-angle gallery for accessories that ship with more than one hero
// shot (e.g. the Travel Case has a closed hero, an interior-loaded shot,
// and a features graphic). Any slug not listed here returns null so the
// PDP falls back to the single hero image behaviour.
const ACCESSORY_GALLERIES = {
  "travel-case-cooler": [
    "/product-photos/travel-case-cooler/hero.webp",
    "/product-photos/travel-case-cooler/open.webp",
    "/product-photos/travel-case-cooler/features.webp",
  ],
};

export function getAccessoryGallery(slug) {
  return ACCESSORY_GALLERIES[slug] || null;
}

export function getAccessoryVariantPhoto(slug, packSize) {
  return ACCESSORY_VARIANT_PHOTOS[slug]?.[packSize] || null;
}

// Bundle composite photos (two vials side-by-side). Rendered in a wide 3:2
// frame — see BundleCard / BundlePage. Any bundle slug not listed here falls
// back to the ProductVisual constellation placeholder.
const BUNDLE_PHOTOS = {
  "metabolic-stack": "/product-photos/bundles/metabolic-stack.webp",
  "nootropic-stack": "/product-photos/bundles/nootropic-stack.webp",
  "aesthetic-stack": "/product-photos/bundles/aesthetic-stack.webp",
  "longevity-stack": "/product-photos/bundles/longevity-stack.webp",
  "reconstitution-kit": "/product-photos/bundles/reconstitution-kit.webp",
  "reconstitution-kit-volume": "/product-photos/bundles/reconstitution-kit-volume.webp",
};

export function getBundlePhoto(slug) {
  return BUNDLE_PHOTOS[slug] || null;
}

// Best available primary photo for ANY product/bundle regardless of format.
// Used by the nav search dropdown so every result surfaces its brand
// visual — the buyer scans by shape and colour, not just text. Falls
// through in preference order:
//   1. Bundle composite (bundles have their own hero shot).
//   2. Vial/vial-kit hero (also used by ProductCard for those formats).
//   3. PEN photo tab (pen kits), then SEALED / OPEN as fallbacks.
//   4. Accessory hero (single square crop).
// Returns null when no asset exists for the slug — the caller should
// render a neutral placeholder rather than a broken img.
export function getPrimaryProductPhoto(product) {
  if (!product || !product.slug) return null;
  return (
    getBundlePhoto(product.slug) ||
    getVialPhoto(product.slug) ||
    getProductPhoto(product.slug, "PEN") ||
    getProductPhoto(product.slug, "SEALED") ||
    getProductPhoto(product.slug, "OPEN") ||
    getAccessoryPhoto(product.slug) ||
    null
  );
}

// Multi-angle gallery for a Reconstitution Kit bundle PDP. Order mirrors the
// physical unboxing flow: (1) primary composite shot, (2) Bacteriostatic
// Water, (3) Mixing Syringe + Needle, (4) Alcohol Prep Wipes, (5) Insulin
// Syringes. Nulls dropped so a kit only shows angles that actually have an
// asset. Non-recon-kit bundles return an empty array — the caller then
// falls back to rendering the single composite shot.
export function getReconstitutionKitGallery(slug) {
  if (!slug || !slug.startsWith("reconstitution-kit")) return [];
  return [
    getBundlePhoto(slug),
    ACCESSORY_PHOTOS["bac-water"],
    ACCESSORY_PHOTOS["mixing-syringe-needle-3ml-23g"],
    ACCESSORY_PHOTOS["alcohol-prep-wipes-100"],
    ACCESSORY_PHOTOS["insulin-syringes-30g-8mm-1ml"],
  ].filter(Boolean);
}
